module.exports = __webpack_public_path__ + "static/media/tools.aac7ac63.svg";